<template>
  <div>
    <v-row class="mt-7">
      <v-col cols="12">
        <naj-item-table
          :data-items="todaySessionsList"
          :headers="headers"
          :items-per-page="(todaySessionsList||[]).length"
          :server-items-length="(todaySessionsList||[]).length"
          :loading="loading"
        >
          <template
            slot="caseCode"
            slot-scope="{item}"
          >
            <div class="info-item-details-title">
              {{ local.home.tabCommon.caseCode }}
            </div>
            <div class="info-item-details-value mt-3">
              {{ item.caseCode }}
            </div>
          </template>

          <template
            slot="sessionDateSlot"
            slot-scope="{item}"
          >
            <div class="info-item-details-title">
              {{ local.home.tabCommon.today }}
            </div>
            <div class="info-item-details-value">
              {{ getDayArabicName(item.sessionDate) }} {{ getDayMonthHijri(item.sessionDate) }} {{ getTime12Format(item.appointmentStartDate) }}{{ isAm(item.appointmentStartDate)? local.calendar.amShort: local.calendar.pmShort }}
            </div>
          </template>

          <template
            slot="mechanism"
            slot-scope="{item}"
          >
            <div class="info-item-details-title">
              {{ local.home.tabCommon.sessionMechanism }}
            </div>
            <div class="info-item-details-value">
              <template v-if="item.isVideoConference">
                <template>
                  <span>
                    {{ local.home.upcomingSessions.remoteSession }}
                  </span>
                </template>
                <v-tooltip
                  v-if="isAllowedShowAttendanceRegister(item) && item.isVideoConference"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="var(--app-primary-color)"
                      class="copy-icon ml-1"
                      v-bind="attrs"
                      left
                      v-on="on"
                      @click="copyURL(item)"
                    >
                      mdi-content-copy
                    </v-icon>
                  </template>
                  <span> {{ local.home.upcomingSessions.copyLink }}</span>
                </v-tooltip>
              </template>
              <template v-else-if="isRemoteArgumentOrCaseManagementELitigation(item) || item.sessionTypeId == sessionTypes.expert">
                <span>{{ local.caseFile.cards.sessionTypes.chatSession }}</span>
              </template>
              <template v-else>
                <v-icon
                  color="var(--app-primary-color)"
                  class="copy-icon mx-0"
                  left
                >
                  mdi-map-marker
                </v-icon>
                <span>{{ local.caseFile.cards.sessionTypes.attendance }}</span>
                <span> {{ local.home.upcomingSessions.courtLocation }} </span>
              </template>
            </div>
          </template>

          <template
            slot="action"
            slot-scope="{item }"
          >
            <div class="mx-4 action-btn-wrapper">
              <naj-button
                v-if="isAllowedShowAttendanceRegister(item) && !item.userHasSessionAttendanceRecord"
                type="button"
                size="small"
                @click="confirmAttendanceRegister(item)"
              >
                {{ local.home.upcomingSessions.attendanceRegister }}
              </naj-button>

              <naj-button
                v-if="isAllowedShowAttendanceRegister(item) && item.userHasSessionAttendanceRecord && item.isVideoConference"
                size="small"
                type="button"
                @click="openVideoConference(item.objectKey)"
              >
                {{ local.home.upcomingSessions.enterSession }}
              </naj-button>
            </div>
            <naj-button
              v-if="item.userCanAttestOnDabt"
              class="cursor-pointer"
              @click="openSessionInfo(item)"
            >
              {{ local.caseFile.cards.session.attest }}
            </naj-button>
            <naj-button
              v-else-if="!item.userCanAttestOnDabt && item.sessionStatusId == sessionStatus.finished"
              class="cursor-pointer"
              @click="openSessionInfo(item)"
            >
              {{ local.caseFile.cards.session.show }}
            </naj-button>
          </template>
        </naj-item-table>
      </v-col>
    </v-row>

    <naj-confirmation
      :show-modal="showAttendanceRegister"
      :max-width="771"
      :title="local.home.upcomingSessions.attendanceRegister"
      :show-close-btn="true"
      @cancel="() => {
        showAttendanceRegister = false
        pledged = false;
      }"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <div>
              <p class="attendanceRegister-title-header">
                {{ local.home.upcomingSessions.attendanceRegisterPart1 }}
              </p>
              <h6 class="attendanceRegister-title-condition">
                {{ local.home.upcomingSessions.termsAndConditions }}
              </h6>
            </div>
            <div class="details__documentList">
              <div
                class="details__documentItem"
                style="width:100%"
              >
                {{ local.home.upcomingSessions.attendanceRegisterFirstConditions }}
              </div>
              <div
                class="details__documentItem"
                style="width:100%"
              >
                {{ local.home.upcomingSessions.attendanceRegisterSecondConditions }}
              </div>
            </div>
            <p class="text-condition">
              {{ local.home.upcomingSessions.attendanceRegisterPart2 }}
            </p>
          </v-col>
        </v-row>
      </template>
      <template slot="actions">
        <naj-button
          v-if="selectedSession"
          :disabled="!pledged"
          @click="registerToSession(selectedSession.objectKey)"
        >
          {{ local.home.upcomingSessions.attendanceRegister }}
        </naj-button>
      </template>
      <template slot="footer-content">
        <naj-input
          :type-id="formFieldType.checkbox"
          :value.sync="pledged"
          :label="local.home.upcomingSessions.agreeOnTermsAndConditions"
        ></naj-input>
      </template>
    </naj-confirmation>

    <naj-confirmation
      :show-modal="showRedirectToSessionModal"
      :max-width="750"
      :is-persistent="true"
      :title="local.home.upcomingSessions.goToSession"
      :show-close-btn="false"
      @cancel="() => {
        showRedirectToSessionModal = false
        redirectToSessionLink = null;
      }"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="success">
              <template slot="content">
                {{ local.home.upcomingSessions.toRedirectToSessionLink }}
                <a
                  :href="redirectToSessionLink"
                  target="_blank"
                  class="redirect-session-link"
                >
                  {{ local.common.clickHere }}
                </a>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>
    <template>
      <div>
        <pdf-dabt-attestation-modal
          :sessions-items="todaySessionsList"
          :selected-session-index-prop="selectedSessionIndex"
          :modal-visibility="showSessionInfoModal"
          @modalClose="closeSessionInfo"
          @reloadTodaySessions="reloadTodaySessions"
        >
        </pdf-dabt-attestation-modal>
      </div>
    </template>
    <qaim-evaluation
      v-if="showEvaluationModal"
      :request-evaluations-code="qaimConfig.requestEvaluationsCodes.sessions"
      :ref-num="sessionObjectKeyData"
      :is-lawsuit-request="true"
      @updateShowEvaluationModal="updateShowEvaluationModal()"
    >
    </qaim-evaluation>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapGlobalActions, mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
import { getDayArabicName, getDayMonthHijri, getTimePartArabic, getTime12Format, isAm, getHoursDifference } from '@/helpers/utils';
import { sessionTypes, sessionStatus, userType, attestationSigningMethod } from '@/helpers/enum';
import SessionCalendar from '../../pages/calendar.vue';
import pdfDabtAttestationModal from '../../../cases/pdf-dabt-attestation-modal';
import qaimEvaluation from '@/modules/lawsuit/components/qaim-evaluations';

export default {
  name: 'SessionsGridTab',
  components: {
    SessionCalendar,
    pdfDabtAttestationModal,
    qaimEvaluation,
  },
  data() {
    return {
      loading: false,
      todaySessionsList: [],
      showAttendanceRegisterValidation: false,
      attendanceRegisterValidationMessage: '',
      showAttendanceRegister: false,
      showSessionInfoModal: false,
      selectedSessionIndex: 0,
      sessionStatus,
      selectedSession: null,
      pledged: false,
      selectedSession: null,
      sessionTypes,
      userInfo: null,
      getDayArabicName,
      getDayMonthHijri,
      getTimePartArabic,
      getTime12Format,
      getHoursDifference,
      isAm,
      calendar: false,
      grid: true,
      headers: [
        {
          value: 'caseCode',
          text: this.local.home.tabCommon.caseCode,
          class: 'caseCode-header',
        },
        {
          value: 'sessionType',
          text: this.local.home.tabCommon.sessionType,
        },
        {
          value: 'court',
          text: this.local.home.tabCommon.courtName,
        },
        {
          value: 'subCircle',
          text: this.local.home.tabCommon.subCircleName,
        },
        {
          value: 'sessionDateSlot',
          isCustomTemplate: true,
        },
        {
          value: 'sessionStatus',
          text: this.local.caseFile.cards.session.statusDisplayName,
        },
        {
          value: 'mechanism',
          isCustomTemplate: true,
        },
        {
          value: 'action',
          isCustomTemplate: true,
          class: 'action-item',
        },
      ],
      showRedirectToSessionModal: false,
      redirectToSessionLink: null,
      showEvaluationModal: false,
      sessionObjectKeyData: '',
    };
  },
  computed: { ...mapGlobalState(['qaimConfig']) },
  watch: {},
  created() {
    this.getUserInfo()
      .then((user) => {
        this.userInfo = user;
        this.getTodaySessions();
      });
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapCasesActions([
      'getMyTodaySessions',
      'validationAttendanceRegister',
      'getVideoConference',
      'addAttendanceRegisterToSession',
    ]),
    getTodaySessions() {
      this.loading = true;
      this.getMyTodaySessions()
        .then((res) => {
          this.$set(this, 'todaySessionsList', res.data);
        })
        .finally(() => (this.loading = false));
    },
    reloadTodaySessions(value, isVideoConference) {
      this.$set(this, 'todaySessionsList', []);
      this.sessionObjectKeyData = value;
      if (isVideoConference) this.showEvaluationModal = true;
      this.getTodaySessions();
    },
    isAllowedShowAttendanceRegister(session) {
      return (this.userInfo &&
        ((session.sessionStatusId == sessionStatus.new || session.sessionStatusId == sessionStatus.inProgress)
          && (session.sessionTypeId == sessionTypes.pleadingSession || session.sessionTypeId == sessionTypes.judgmentHearingSession
            || session.sessionTypeId == sessionTypes.firstHearingSession)));
    },
    confirmAttendanceRegister(session) {
      this.loading = true;
      this.selectedSession = session;

      this.validationAttendanceRegister(session.objectKey).then(() => {
        this.showAttendanceRegister = true;
      }).catch(() => {

      }).finally(() => (this.loading = false));
    },
    registerToSession(sessionObjectKey) {
      this.loading = true;
      this.addAttendanceRegisterToSession(sessionObjectKey).then(() => {
        this.showAttendanceRegister = false;
        this.pledged = false;
        this.getTodaySessions();
        this.toaster.success(this.local.home.upcomingSessions.registrationSuccessful);
        if (this.selectedSession && this.selectedSession.videoConferenceUrl) {
          this.openVideoConference(sessionObjectKey);
        }
      }).catch(() => {
        this.showAttendanceRegister = false;
      }).finally(() => (this.loading = false));
    },
    openVideoConference(sessionObjectKey) {
      this.loading = true;
      this.getVideoConference(sessionObjectKey)
        .then((res) => {
          this.redirectToSessionLink = res.data;
          this.showRedirectToSessionModal = true;
        })
        .finally(() => (this.loading = false));
    },
    isRemoteArgumentOrCaseManagementELitigation(session) {
      return session.sessionTypeId == sessionTypes.remoteArgument || session.sessionTypeId == sessionTypes.caseManagementELitigation;
    },
    changeToGrid() {
      this.calendar = false;
      this.grid = true;
    },
    changeToCalender() {
      this.grid = false;
      this.calendar = true;
    },
    async copyURL(session) {
      if (session.videoConferenceUrl) {
        await navigator.clipboard.writeText(session.videoConferenceUrl);
        this.toaster.success(this.local.home.upcomingSessions.copied);
      }
    },
   openSessionInfo(session) {
      this.showSessionInfoModal = true;
      this.selectedSession = session;
      this.selectedSessionIndex = this.todaySessionsList.findIndex(a => a.id == session.id);
    },
    closeSessionInfo() {
      this.showSessionInfoModal = false;
      this.selectedSessionIndex = 0;
    },
    updateShowEvaluationModal() {
      this.showEvaluationModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__prepend-inner {
  transform: scale(1, 1);
}

::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}

::v-deep .info-item-details.caseCode-header {
  .info-item-details-value {
    font-size: 24px;
  }
}

.action-btn-wrapper {
  min-width: 130.625px !important;
}

.redirect-session-link {
  color: #144afa;
  display: inline;
}

.bgc {
  background: #158e8d;
  display: inline-block;
  border-radius: 5px;
  padding: 4px 10px 4px 10px;
}

.icon-grid-style {
  font-size: 25px;
  color: #ffffff;
}

.icon-calendar-style {
  font-size: 25px;
  color: #ffffff;
  margin-right: 10px;
}

.icon-style-focus {
  color: #158e8d;
  background-color: #ffffff;
  border-radius: 3px;
}
</style>
